import {useIntl} from 'react-intl';
import FormField from 'Components/FormComponents/FormField';

const ProgramFinderMeta = ({hitsNr, sortingForm, sortState, setSortState, resultsText, replaceCount}) => {
  const intl = useIntl();

  return (
    <div className="program-finder-meta flex justify-between items-center">
      <div className="program-finder-meta__count">
        {replaceCount ?
          replaceCount : intl.formatMessage({id: resultsText}, {count: hitsNr})
        }
      </div>
      {sortState && sortingForm && setSortState &&
        <div className="hidden md:block program-finder-meta__sort">
          <FormField fieldConfig={sortingForm[0]} state={sortState} setState={setSortState}/>
        </div>
      }
    </div>
  );
};

export default ProgramFinderMeta;
